import React from "react";
import "./App.css";
import Setup from "./Setup";

function App() {
  return (
    <div className="container">
      <Setup />
    </div>
  );
}

export default App;
